module.exports = __webpack_public_path__ + "media/phiphi/phiphi_from_boat-a454b9c7.jpg";